module.exports = __webpack_public_path__ + "img/gPay-Phone.7b9ee1c7.svg";